import { Decodable } from './_decodable'

class StockSettings extends Decodable {
    id?: number
    stockControlEnabled?: boolean
    minStockAlertEnabled?: boolean
    minStockQuantity?: number
    blockProposalWithoutStock?: boolean
    stockDeductionMoment?: number
    createdAt?: Date
    updatedAt?: Date

    protected _map = {
        createdAt: (e: any) => this.parseDate(e),
        updatedAt: (e: any) => this.parseDate(e),
    }
}

export {
    StockSettings
}
